<div>
  @if (header) {
    <div class="lease-rows__header-toolbar" [class.lease-rows__header-toolbar--stacked]="headerActionBelow">
      <h4 class="list-header">{{ 'LEASE_AGREEMENT_ROW.LIST_HEADER' | translate }}</h4>
      <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="ADD_MORE" (click)="createItem()"></astral-button>
    </div>
  }

  @if (!header) {
    <div class="lease-rows__toolbar">
      <div class="lease-rows__toolbar-create">
        <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="ADD_MORE" (click)="createItem()"></astral-button>
      </div>

      <div class="lease-rows__toolbar-history">
        <astral-checkbox [control]="displayFormGroup.controls['displayHistory']"></astral-checkbox>
      </div>
    </div>
  }

  <app-list-view
    [columnDefinition]="columnDefinition"
    [contextMenuDefinition]="menuDefinition"
    [itemsSource]="itemsSource"
    [preferencesKey]="'rent.lease-rows.list'"
    [rowFactory]="listViewRowFactory"
    [rowTrackBy]="listViewRowTrackBy"
    (rowClick)="onRowClicked($event)"
  ></app-list-view>
</div>

<ng-template #leaseAgreementSidebarContent>
  @if (selectedRow) {
    <app-lease-row-form
      [leaseAgreementCategory]="leaseAgreementCategory"
      [row]="selectedRow"
      [currencyCode]="currency"
      [articles]="articles"
      [propertyTaxRentalChange]="propertyTaxRentalChange"
      [cultureName]="cultureName"
      [companyId]="companyId"
      [showProject]="showProject"
      (completed)="onCompleted($event)"
    ></app-lease-row-form>
  }
</ng-template>
